<app-header></app-header>

<div class="auditPage">

    <div class="cards">

<div class="cardsAc">
    <ng-container *ngFor="let audit of audits">
        <div class="card" *ngIf="audit.name">
            <h4>{{audit.name}}</h4>
            <!-- <p>{{pendingAchieve.programData.desc}}</p> -->
         
    
            <div class="awards">
          <div class="award_row">
            <div class="startDate"><span class="datehead">Start Date</span><span class="dateDetail" *ngIf="audit.schedule && audit.schedule.start && audit.schedule.start.date && audit.schedule.start.time">{{getFormattedDate(audit.schedule.start.date)}}</span></div>
            <div class="startDate"><span class="datehead">End Date</span><span class="dateDetail" *ngIf="audit.schedule && audit.schedule.end && audit.schedule.end.date && audit.schedule.end.time">{{getFormattedDate(audit.schedule.end.date)}}</span></div>
            <div class="startDate"><span class="datehead">Status</span>
                <span class="dateDetail" *ngIf="audit.status && audit.status.name == 'Completed'">Completed</span>
                <span class="dateDetail" *ngIf="audit.status && audit.status.name == 'In Progress'">In Progress</span>
                <span class="dateDetail" *ngIf="audit.status && audit.status.name == 'Not Started'">Not Started</span>
                <span class="dateDetail" *ngIf="audit.status && audit.status.name == 'Finished'">Finished</span>
            </div>
          
          </div>
            </div>
            <div class="progAc">
                <div class="continue" (click)="onClickView()">
                    VIEW AUDIT <i style="font-size: 12px; transform: translateY(2px);" class="flaticon-next arrow"></i></div>
            </div>
        </div>
    </ng-container>

</div>

           
    </div>

</div>